module.exports = __webpack_public_path__ + "static/img/testimony (44).91078633.jpg";